import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M19.764 12.964l-2.282 2.31 2.282 2.311-1.3 1.262-2.254-2.284-2.255 2.284-1.299-1.262 2.282-2.31-2.282-2.311 1.3-1.262 2.254 2.284 2.255-2.284 1.299 1.262zm-3.5 8.413c-3.363 0-6.098-2.713-6.098-6.048S12.9 9.28 16.265 9.28c3.362 0 6.098 2.714 6.098 6.049 0 3.335-2.736 6.048-6.098 6.048h-.001zM6.41 12.813L2.821 9.926l1.146-1.4 2.203 1.772 4.774-5.62 1.39 1.162-5.924 6.973zm9.856-5.156c-.29 0-.576.017-.857.048C14.928 3.925 11.678 1 7.735 1 3.463 1 0 4.435 0 8.671c0 4.237 3.463 7.672 7.735 7.672.29 0 .576-.017.857-.048.48 3.78 3.73 6.705 7.673 6.705C20.537 23 24 19.565 24 15.329c0-4.237-3.463-7.672-7.735-7.672h.001z',
    ],
};
const IconConfirmOrDeny = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconConfirmOrDeny.displayName = 'IconConfirmOrDeny';

export { IconConfirmOrDeny };
//# sourceMappingURL=IconConfirmOrDeny.js.map
